import React from "react";
import { renderToString } from "react-dom/server";
import { PinSvg } from "./PinSvg";
import { PhosphorCheck, PhosphorCircle, PhosphorX } from "components/Atoms/PhosphorIcon";

export type ShowMapPinType = {
  type: "show";
  phase: server.dto.AppointmentPhases;
}

export const getShowMapPin = (pin: ShowMapPinType) => {
  const element = document.createElement("div");
  element.innerHTML = renderToString(<ShowPin phase={pin.phase} />);
  return element;
};

interface ShowPinProps {
  phase: server.dto.AppointmentPhases;
}

const ShowPin = (props: ShowPinProps) => {
  const empty = props.phase === "unknown";

  return <div className="google-map-pin-wrapper">
    {!empty && <div className="google-map-pin-content google-map-pin-content-show">
      {props.phase === "confirmed" && <PhosphorCheck iconColor="white" iconSize="small" iconWeight="bold" />}
      {props.phase === "option" && <PhosphorCircle iconColor="white" iconSize="small" iconWeight="bold" />}
      {props.phase === "cancelled" && <PhosphorX iconColor="white" iconSize="small" iconWeight="bold" />}
    </div>}
    <PinSvg width={27} height={43} empty={empty} fillColor="var(--map-show-purple)" />
  </div>
}